// extracted by mini-css-extract-plugin
export default {"container":"SupportFooter_container__N0H1w","secured":"SupportFooter_secured__LPH9v","contact":"SupportFooter_contact__laZ+1"};